import { render, staticRenderFns } from "./ImportV2.vue?vue&type=template&id=53a76027&scoped=true&"
import script from "./ImportV2.vue?vue&type=script&lang=js&"
export * from "./ImportV2.vue?vue&type=script&lang=js&"
import style0 from "./ImportV2.vue?vue&type=style&index=0&id=53a76027&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a76027",
  null
  
)

export default component.exports